type CategoryWithDates = {
  updatedDate?: string | Date | null;
  createdDate?: string | Date | null;
  updated_date?: string | Date | null;
  created_date?: string | Date | null;
};

/**
 * Get updated/created from category, supporting both camelCase and snake_case API responses.
 */
export const getCategoryDates = (
  category: CategoryWithDates,
): {
  updated: string | Date | null | undefined;
  created: string | Date | null | undefined;
} => ({
  updated: category.updatedDate ?? category.updated_date,
  created: category.createdDate ?? category.created_date,
});
